/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Субъект страны (регион)
 * @export
 * @interface CountrySubject
 */
export interface CountrySubject {
  /**
   * UUID субъекта
   * @type {string}
   * @memberof CountrySubject
   */
  uuid: string
  /**
   * Название субъекта
   * @type {string}
   * @memberof CountrySubject
   */
  name: string
  /**
   * Код региона
   * @type {string}
   * @memberof CountrySubject
   */
  regionCode: string
}

/**
 * Check if a given object implements the CountrySubject interface.
 */
export function instanceOfCountrySubject(
  value: object
): value is CountrySubject {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('regionCode' in value) || value['regionCode'] === undefined)
    return false
  return true
}

export function CountrySubjectFromJSON(json: any): CountrySubject {
  return CountrySubjectFromJSONTyped(json, false)
}

export function CountrySubjectFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CountrySubject {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    regionCode: json['regionCode'],
  }
}

export function CountrySubjectToJSON(value?: CountrySubject | null): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    regionCode: value['regionCode'],
  }
}
